import { render, staticRenderFns } from "./footer-bar.vue?vue&type=template&id=3b338d54&scoped=true&"
import script from "./footer-bar.vue?vue&type=script&lang=js&"
export * from "./footer-bar.vue?vue&type=script&lang=js&"
import style0 from "./footer-bar.vue?vue&type=style&index=0&id=3b338d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b338d54",
  null
  
)

export default component.exports